import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const NoImageIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				stroke="CurrentColor"
				strokeWidth={0.75}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M3.37 20.1C2.43 18.97 2 17.31 2 15V9C2 4 4 2 9 2H15C17.19 2 18.8 2.38 19.92 3.23"
			/>
			<path
				opacity="0.4"
				stroke="CurrentColor"
				strokeWidth={0.75}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
			/>
			<path stroke="CurrentColor" strokeWidth={0.75} strokeLinecap="round" strokeLinejoin="round" d="M22 2L2 22" />
			<g opacity="0.4">
				<path
					stroke="CurrentColor"
					strokeWidth={0.75}
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M21.9709 7.99023C21.9909 8.31023 22.0009 8.65023 22.0009 9.00023V15.0002C22.0009 20.0002 20.0009 22.0002 15.0009 22.0002H9.00094C8.26094 22.0002 7.58094 21.9602 6.96094 21.8602"
				/>
				<path
					stroke="CurrentColor"
					strokeWidth={0.75}
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M11.4297 16.4502C11.7297 16.7502 12.2197 16.7502 12.5197 16.4502L17.5497 11.4102C18.3297 10.6302 19.5897 10.6302 20.3697 11.4102L21.9997 13.0502"
				/>
			</g>
		</svg>
	</SvgIcon>
)

export default NoImageIconAtom
